import Guides from "../GuidesTemplate";

const easyEdaLink = "https://easyeda.com/"
const altiumDesignerLink = "https://www.altium.com/altium-designer"
const fusionDesignerLink = "https://www.autodesk.com/solutions/pcb-design-software"

const easyEdaPreviewIMG = "/media/img/easyeda.png"
const guideContent = {
    "img": "/media/img/pcbs.JPEG",
    "title": "Designing First PCB",
    "content": (
        <>
            <p>After this guide you will be able to design your own pcb and you will learn useful safety and best practice tips and tricks</p>
            <div className={"pcb-guide-content"}>
                <div>
                    <p>You will need the following for designing own PCBs:</p>
                    <ul>
                        <li>Laptop/PC (Phone will theoretically work)</li>
                        <li>Basic knowledge of electronics</li>
                        <li>Patience</li>
                        <li>Designing software like <a href={easyEdaLink}>Easy Eda</a>
                            , <a href={altiumDesignerLink}>Altium Designer</a> or <a href={fusionDesignerLink}>Fusion
                                360
                                PCB
                                designer</a></li>
                    </ul>
                </div>
                <div className={"pcb-guide-content-div-easy-eda-preview"}>
                    <img src={easyEdaPreviewIMG}/>
                </div>
            </div>
        </>
    )
}

export default function ChooseSolderingDevice() {

    return (
        <>
            <Guides content={guideContent}></Guides>
        </>
    )
}